var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var IconSearch = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "md" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, props = __rest(_a, ["size", "className"]);
    return (_jsx("span", __assign({ className: "mex-icon mex-icon--".concat(size, " ").concat(className) }, props, { children: _jsxs("svg", __assign({ width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("g", __assign({ clipPath: "url(#clip0_1_90)" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 13.5C22 18.1944 18.1944 22 13.5 22C8.80558 22 5 18.1944 5 13.5C5 8.80558 8.80558 5 13.5 5C18.1944 5 22 8.80558 22 13.5ZM20.1452 21.6301C18.3351 23.1113 16.0213 24 13.5 24C7.70101 24 3 19.299 3 13.5C3 7.70101 7.70101 3 13.5 3C19.299 3 24 7.70101 24 13.5C24 16.0213 23.1113 18.3351 21.6301 20.1452L28.6934 27.2084C29.1034 27.6185 29.1034 28.2833 28.6934 28.6933C28.2833 29.1034 27.6185 29.1034 27.2085 28.6933L20.1452 21.6301Z" }) })), _jsx("defs", { children: _jsx("clipPath", __assign({ id: "clip0_1_90" }, { children: _jsx("rect", { width: "32", height: "32", fill: "white" }) })) })] })) })));
};
export default IconSearch;
